import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { useIntl } from "react-intl";
import { CanvaButton } from "../component/socialPost/creator/CanvaButton";

export const CanvaDesigner = () => {
  const intl = useIntl();
  const [callbackUrl, setCallbackUrl] = useState<string | null>(null);
  const [isFromMobileApp, setIsFromMobileApp] = useState(false);

  useEffect(() => {
    // Detectar si viene de la app móvil mediante query params
    const urlParams = new URLSearchParams(window.location.search);
    const callback = urlParams.get("callback_url");

    if (callback) {
      setCallbackUrl(decodeURIComponent(callback));
      setIsFromMobileApp(true);
      console.log(
        "🎨 [Web] Sesión iniciada desde app móvil, callback:",
        callback
      );
    }

    // Detectar si hay parámetros de estado de Canva (por si viene de un redirect)
    const status = urlParams.get("status");
    const designTitle = urlParams.get("design_title");

    if (status && callback) {
      console.log("🎨 [Web] Estado detectado:", status, designTitle);

      if (status === "success" && designTitle) {
        // Auto-redirigir si hay éxito confirmado
        setTimeout(() => {
          try {
            window.location.href = decodeURIComponent(callback);
          } catch (error) {
            console.error("🎨 [Web] Error en auto-redirect:", error);
          }
        }, 2000);
      }
    }
  }, []);

  const handleCanvaPublish = (file: any, picture: string) => {
    // Este callback se ejecuta cuando Canva publica un diseño
    console.log("🎨 [Web] Diseño publicado:", { file, picture });

    // Si viene de la app móvil, construir deep link manualmente
    if (isFromMobileApp) {
      console.log(
        "🎨 [Web] Construyendo deep link para regresar a la app móvil..."
      );

      // Crear el deep link con los datos del diseño (incluyendo base64 completo)
      const designTitle = file.name || "Diseño de Canva";
      const designId = Date.now().toString();

      // Asegurar que el base64 esté completo
      const base64Image = picture; // Ya viene con data:image/png;base64, prefix

      console.log("🎨 [Web] Datos del diseño:");
      console.log("- Título:", designTitle);
      console.log("- ID:", designId);
      console.log("- Base64 length:", base64Image.length);
      console.log("- Base64 preview:", base64Image.substring(0, 100) + "...");

      const deepLinkUrl = `wembii://canva/callback?status=success&design_title=${encodeURIComponent(
        designTitle
      )}&image_base64=${encodeURIComponent(base64Image)}&design_id=${designId}`;

      // También crear universal link como fallback
      const universalLinkUrl = `https://app.wembii.com/app/canva-callback?status=success&design_title=${encodeURIComponent(
        designTitle
      )}&image_base64=${encodeURIComponent(base64Image)}&design_id=${designId}`;

      console.log("🎨 [Web] Deep link generado:", deepLinkUrl);
      console.log("🎨 [Web] Universal link generado:", universalLinkUrl);

      // Mostrar mensaje antes de redirigir
      const designName = file.name || "tu diseño";
 

      // Redirigir después de un pequeño delay
      setTimeout(() => {
        try {
          // Intentar primero con el deep link personalizado
          window.location.href = deepLinkUrl;

          // Fallback: si no funciona, intentar con universal link después de un tiempo
          setTimeout(() => {
            if (document.hasFocus()) {
              // Si aún estamos en la web, intentar universal link
              console.log("🎨 [Web] Intentando con universal link...");
              window.location.href = universalLinkUrl;
            }
          }, 2000);
        } catch (error) {
          console.error("🎨 [Web] Error redirigiendo a la app:", error);
          alert(
            "Error al regresar a la app. Por favor, abre la app Wembii manualmente."
          );
        }
      }, 1500);
    } else {
      // Flujo normal para web o iframe
      // Notificar a la aplicación padre si está en un iframe
      if (window.parent && window.parent !== window) {
        window.parent.postMessage(
          {
            type: "CANVA_DESIGN_SUCCESS",
            data: { file, picture, exportUrl: picture, designTitle: file.name },
          },
          "*"
        );
      }

      // Mostrar mensaje de éxito
      alert(`Diseño "${file.name}" creado exitosamente!`);
    }
  };

  return (
    <Container
      className="h-100 d-flex align-items-center justify-content-center"
      fluid
    >
      <Row className="w-100">
        <Col md={{ offset: 3, size: 6 }} sm="12">
          <Card className="shadow-lg">
            <CardBody className="text-center p-5">
              {/* Indicador de sesión desde app móvil */}
              {isFromMobileApp && (
                <div className="alert alert-info mb-4">
                  <i className="fas fa-mobile-alt me-2"></i>
                  <strong>Sesión desde App Móvil</strong>
                  <br />
                  <small>
                    Cuando termines tu diseño, regresarás automáticamente a la
                    app Wembii
                  </small>
                </div>
              )}

              <div className="mb-4">
                <h2 className="text-primary mb-3">
                  {intl.formatMessage({ id: "app.canvaDesigner.title" })}
                </h2>
                <p className="text-muted">
                  {intl.formatMessage({ id: "app.canvaDesigner.subtitle" })}
                </p>
              </div>

              <div className="mb-4">
                <CanvaButton onPublish={handleCanvaPublish} disabled={false} />
              </div>

              <div className="mt-4">
                <small className="text-muted">
                  {intl.formatMessage({ id: "app.canvaDesigner.autoSave" })}
                </small>
              </div>

              {/* Botón para regresar manualmente a la app móvil */}
              {isFromMobileApp && callbackUrl && (
                <div className="mt-4">
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => {
                      if (
                        window.confirm(
                          "¿Quieres regresar a la app sin terminar tu diseño?"
                        )
                      ) {
                        const url = new URL(callbackUrl);
                        url.searchParams.set("status", "cancelled");
                        window.location.href = url.toString();
                      }
                    }}
                  >
                    <i className="fas fa-arrow-left me-2"></i>
                    Regresar a la App
                  </button>
                </div>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
